import { OrgMemberRole } from "@garther/interfaces";

export const RoleOptions = [
  { value: OrgMemberRole.MEMBER, label: "Member" },
  { value: OrgMemberRole.ADMIN, label: "Admin" },
  { value: OrgMemberRole.OWNER, label: "Owner" }
];
